import Plyr from "plyr-react";
import "plyr-react/dist/plyr.css";
import posthog from "posthog-js";
import { memo, useState } from "react";
import { EventAction, EventObject } from "services/analytics.service";
import { classNames } from "@library/utils/classNames";
import styles from "./VideoPlayer.module.css";

const ProgrammaticVideoComponent = () => {
  return (
    <Plyr
      source={{
        type: "video",
        sources: [{ src: "686272874", provider: "vimeo" }],
        poster: "/assets/product/spantagging.png",
      }}
      options={{
        ratio: "1730:1080",
        speed: {
          selected: 1.25,
          options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2], // These options are the default options
        },
        // vimeo: {
        //   byline: false,
        //   portrait: false,
        //   title: false,
        //   speed: true,
        //   transparent: true,
        // },
        // Would love to set transparent: true, but this makes the Vimeo controls show up.
      }}
    />
  );
};

const ProgrammaticVideo = memo(ProgrammaticVideoComponent);
// Memo to avoid re-rendering component as Plyr does not seem to like that (and will disappear)

const VideoPlayer = () => {
  const [hideOverlay, setHideOverlay] = useState(false);

  const handlePlayClick = () => {
    posthog.capture(`${EventObject.Video} ${EventAction.Played}`, {
      property: "humanloop",
    });
    setHideOverlay(true);
  };
  return (
    <div
      className={classNames(styles.player, "group -m-1 cursor-pointer")}
      onClick={handlePlayClick}
    >
      {/* Negative margin now all around video due to custom thumbnail revealing black background in iframe. */}

      <ProgrammaticVideo />

      {!hideOverlay && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div
            className="absolute z-[51] ml-60 mt-60 h-32 w-32 shrink-0 rounded-full border-2 border-white bg-cover bg-center opacity-0 duration-150 group-hover:opacity-100"
            title="Raza Habib"
            style={{
              backgroundImage: `url(/assets/marketing/people/raza.jpg)`,
            }}
          />
          <div className="z-[1] mt-[105px] rounded-full bg-white px-12 py-8 opacity-0 shadow-c duration-150 group-hover:opacity-100">
            <div className="text-12-14 font-bold text-gray-900">
              Learn how to get hundreds of annotations in minutes.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
